import React from 'react'
import { ProjectModel } from '../../../base/models/projectModel'
import ProjectFormView from './projectFormView'

interface Props {
    project?: ProjectModel
    
}

const UpdateProjectView = ({project}: Props) => {
    return (
        <ProjectFormView isUpdate project={project} />
    )
}

export default UpdateProjectView
